<script setup lang="ts">
import { RouterLink, useRoute } from 'vue-router'
import FlatRouterLinkButton from '@/components/atoms/FlatRouterLinkButton.vue'
import { useSettingsPageLineActivationUserVariableListViewQuery } from './SettingsPageLineActivationUserVariableListView.generated'
import { stringifyUserVariableDataType } from '@/features/userVariable/dataType'
import CenteredPageContainer from '@/components/molecules/CenteredPageContainer.vue'

const route = useRoute('LineActivationSettingUserVariableListView')

const pageQuery = useSettingsPageLineActivationUserVariableListViewQuery({
  fetchPolicy: 'no-cache',
})
</script>

<template>
  <CenteredPageContainer wide>
    <section :class="$style.container">
      <header :class="$style.header">
        <h1>カスタム項目 管理</h1>
        <FlatRouterLinkButton
          variant="primary"
          size="medium"
          :to="{ name: 'LineActivationSettingUserVariableCreateView' }"
          :class="$style.submitButton"
        >
          新規作成
        </FlatRouterLinkButton>
      </header>
      <hr :class="$style.hr" />
      <div :class="$style.containerInner" v-if="pageQuery.result.value">
        <table :class="$style.table">
          <colgroup>
            <col width="75%" />
            <col width="25%" />
          </colgroup>
          <thead>
            <tr>
              <th>項目名</th>
              <th>データ型</th>
            </tr>
          </thead>
          <tbody
            v-if="pageQuery.result.value.userVariableDefinitions.length > 0"
          >
            <tr
              v-for="def of pageQuery.result.value.userVariableDefinitions"
              :key="def.guid"
            >
              <td>
                <RouterLink
                  :to="{
                    name: 'LineActivationSettingUserVariableEditView',
                    params: {
                      entranceGUID: route.params.entranceGUID,
                      userVariableGuid: def.guid,
                    },
                  }"
                  >{{ def.name }}</RouterLink
                >
              </td>
              <td>{{ stringifyUserVariableDataType(def.value.__typename) }}</td>
            </tr>
          </tbody>
          <tbody
            v-else-if="
              pageQuery.result.value.userVariableDefinitions.length === 0
            "
          >
            <tr>
              <td colspan="6" :class="$style.none">
                定義されたカスタム項目がありません
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </CenteredPageContainer>
</template>

<style module lang="scss">
.wrapper {
  margin: 0 auto;
  width: 860px;
}

.container {
  background-color: $color-surface-primary;
  padding: 16px;
  border-radius: 10px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hr {
  border: none;
  border-top: 1px solid $color-border-low-emphasis;
  margin: 16px 0;
}

.containerInner {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.table {
  border-collapse: collapse;

  thead {
    background-color: $color-background-base;

    th {
      padding: 12px;
      text-align: left;
    }
  }

  tbody {
    tr {
      &:not(:first-child) {
        border-top: 1px solid $color-border-low-emphasis;
      }

      td {
        padding: 24px 12px;

        a {
          display: block;
          color: inherit;
          text-decoration: underline;
        }
      }
    }
  }
}

.none {
  text-align: center;
}
</style>
